"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var t = require("io-ts");
var rpc = require("../rpc");
var media_1 = require("./media");
exports.profileService = rpc.extend(media_1.MediaService, rpc.service({
    setAvatar: rpc.method(t.string, t.void),
}));
